import DefaultImage from "../../../assets/images/Default.webp";

function ProductImage({ src }) {
  const imgUrl = src || DefaultImage;
  return <img style={{ width: "100px" }} src={imgUrl} alt="product" />;
}

export default ProductImage;
